module.exports = function anonymous(it
/**/) {
var encodeHTML = typeof _encodeHTML !== 'undefined' ? _encodeHTML : (function (doNotSkipEncoded) {
		var encodeHTMLRules = { "&": "&#38;", "<": "&#60;", ">": "&#62;", '"': "&#34;", "'": "&#39;", "/": "&#47;" },
			matchHTML = doNotSkipEncoded ? /[&<>"'\/]/g : /&(?!#?\w+;)|<|>|"|'|\//g;
		return function(code) {
			return code ? code.toString().replace(matchHTML, function(m) {return encodeHTMLRules[m] || m;}) : "";
		};
	}());var out='<a href="'+encodeHTML(it.Url)+'" target="_blank" class="download-item" data-index="'+encodeHTML(it.itemIndex)+'" style="background-image:url('+encodeHTML(it.Thumb)+')"> <div class="download-item__content"> <span class="download-item__name">'+encodeHTML(it.Name)+'</span> <span class="download-item__size">'+encodeHTML(it.Type)+' '+encodeHTML(it.Size)+'</span> </div> <div class="download-item__hover"> <svg><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="/assets/images/svg-defs-sprite.svg#download-arrow"></use></svg> <span>'+encodeHTML(it.DictionaryText)+' </span> <span>'+encodeHTML(it.Type)+' '+encodeHTML(it.Size)+'</span> </div></a>';return out;
}


/*****************
 ** WEBPACK FOOTER
 ** ./source/scripts/templates/filters/downloads.dot
 ** module id = 250
 ** module chunks = 0 1
 **/